import React, {useEffect} from 'react';
import { getBearerToken } from '@cj-platform/authentication-browser'
import {getEmailAddress} from "../impl/oauth";

export const CJLogin = ({authConfig}) => {

    useEffect(() => {
        doLogin()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authConfig]);

    const doLogin = async () => {
        await getBearerToken()
        await getEmailAddress(authConfig)
        window.location.assign("/");
    }

    return <div/>;
};
